import { Box } from '@chakra-ui/react';
import React from 'react';
import './ckeditor.scoped.css';

const CkeditorDisplay = (props: any) => {
  return (
    <Box className="cke" {...props}>
      {props.children}
    </Box>
  );
};

export default CkeditorDisplay;
